import { domReady } from '@/utils/dom-ready'

domReady(() => {
  const stackedPills = '.stacked-navigation .nav-tabs .nav-item'
  const selectors = document.querySelectorAll(`${stackedPills}.selector`)
  const numberOfSelectors = selectors.length

  // If there are more than 5 selectors, collapse all after the first 4 and activate a "More" button
  // that will reveal them.
  // There is no option to re-collapse after expanding; the idea is that the user will choose one of the selectors to click
  // on at that point.
  if (numberOfSelectors > 5) {

    // Hide selectors after the first 4 that aren't active
    document.querySelectorAll(`${stackedPills}.selector:nth-child(n+5):not(.active)`).forEach(selector => {
      selector.classList.add('d-none', 'd-md-block')
    })

    const moreButton = document.querySelector(`${stackedPills}.more`)
    if (moreButton) {
      moreButton.classList.remove('d-none')
      moreButton.classList.add('d-block', 'd-md-none')

      const moreLink = moreButton.querySelector('a')
      if (moreLink) {
        moreLink.addEventListener('click', () => {
          selectors.forEach(selector => {
            selector.classList.remove('d-none')
            selector.classList.add('d-block')
          })
          moreButton.classList.remove('d-block')
          moreButton.classList.add('d-none')
        })
      }
    }
  }
})
